import { getTodayDateInHotelTimezone as a, isDateBefore as t } from "@amenitiz/design-system";
const r = (e, o) => {
  const n = a();
  return !!(t(e, n) || o && t(e, o));
};
export {
  r as isPastDate
};
